export default __webpack_public_path__ + "static/media/bookmark-grey.49921543.svg";